export default function json(input) {
    if (!input) return {}
    const string = input.toString()

    return JSON.parse(string)
}
